import * as React from 'react';

import {
  RouteComponent,
  Router,
  createBrowserHistory,
} from 'react-resource-router';

import { routes } from './routes';

export const App = (): JSX.Element => {
  return (
    <Router routes={routes} history={createBrowserHistory()}>
      <RouteComponent />
    </Router>
  );
};
